import actionTypes from '../constants/actionTypes/step-action-types';

const initialState = {
    stepNumber: 1
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET:
            return { ...action.payload };
        default:
            return state;
    }
};

export default reducer;
